<template>
  <div class="contract-info-page">
    <!-- 外层card-m容器保持不变 -->
    <card-m
      class="contract-info-card"
      cardWidth="100%"
      cardHeight="100%"
      maxHeight="unset"
      
      :show-filter="false"
    >
    <!-- 修改1：将面包屑导航移动到 card-title 插槽 -->
    <template slot="card-title">
      <AppBreadcrumb
        page-name="合同信息"
        :list="breadcrumbList"
      >
        <template #right-btn>
          <el-button
            type="primary"
            size="mini"
            @click="goToAftersaleInfo"
          >
            售后信息
          </el-button>
        </template>
      </AppBreadcrumb>
    </template>

    <!-- 主内容区域 - 重新设计布局 -->
    <template slot="card-box">
      <!-- 使用Grid容器包裹所有内容 -->
      <div class="contract-dashboard">
        <!-- 上半部分：合同信息区域 -->
        <div class="contract-info-section">
          <card-m
            title="合同信息"
            cardWidth="100%"
            :minHeight="'100%'"
            :cardHeight="'100%'"
            :show-export="true"
            export-file-name="合同信息"
            @export="handleExportContractInfo"
          >
            <template slot="card-box">
              <!-- 使用卡片信息表格展示合同信息 -->
              <CardInfoTable
                ref="contractInfoTable"
                :data="contractInfoItems"
                :items-per-row="contractTableColumns"
                :label-width="isMobile ? '5%' : '10%'"
                :row-height="isMobile ? '26px' : '28px'"
                :font-size="isMobile ? '12px' : '14px'"
                :label-bg-color="'rgba(37, 100, 207, 0.08)'"
                :border-color="'#dcdfe6'"
                :hover-effect="!isMobile"
                :empty-text="''"
              />
              </template>
            </card-m>
          </div>
          <!-- <template slot="card-box"></template> -->
          <!-- 下半部分：订单列表（一级）→ 点开展开看该型号的任务单（二级）
               数据由 orderProgress 组件自己按入口接口拉取，父组件只给合同号和入口来源 -->
          <div class="task-section">
            <orderProgress
              title="订单列表"
              :contract-no="contractInfo.合同编号 || contractId"
              :is-from-project="isFromProject"
              @design-click="handleOrderDesignClick"
              @production-click="handleOrderProductionClick"
            />
          </div>
        </div>
      </template>
    </card-m>
  </div>
</template>

<script>
// import { getOrdersListFromContract } from '@/api/mainapi.js';
// ✅ 订单列表改用新的二级表格组件：一级订单 → 展开看二级任务单
import orderProgress from './orderProgress.vue';
import UserInfoUtils from '@/utils/userInfoUtils.js';
import { getOrdersListFromContract, getOrdersListFromProject, getContractListFromProject, getContractHomeList } from '@/api/mainapi.js';
export default {
  name: 'ContractDetail',
  props: {
    contractId: {
      type: String,
      required: true
    },
    projectName: {
      type: String,
      default: ''
    }
  },

  components: {
    orderProgress
  },  
  data() {
    return {
      // 合同信息
      contractInfo: {
        创建时间: '',
        审核时间: '',
        合同编号: '',
        合同名称: '',
        评审进度: '',
        客户: '',
        销售员: '',
        合同总额: '',
        签订交货期: '',
        回复交货期: '',
        计划完成时间: '',
        交付进度: '',
        网点号: '',
        总字号: '',
        回款: '',
        回款比例: 0
      },
      
      // 筛选条件参数
      taskNoSearchKeyword: '', // 任务单筛选关键词
      productModelSearchKeyword: '', // 产品型号筛选关键词
      contractNoSearchKeyword: '', // 合同号筛选关键词
      departmentSearchKeyword: '', // 生产车间筛选关键词
      productionProgressSearchKeyword: '', // 生产进度筛选关键词
      commitDateSearchKeyword: '', // 下达日期筛选关键词
      planFinishDateSearchKeyword: '', // 计划完工日期筛选关键词
      isIssueSearchKeyword: '', // 是否有异常筛选
      qtySearchKeyword: '', // 数量筛选（对应接口字段 qty，数字类型）
      
      // 分页相关参数
      currentPage: 1,
      pageSize: 50,
      
      // 数据
      workOrderData: [],
      totalCounts: 0,
      loading: false
    };
  },
  computed: {

  projectNo() {
    return this.$route.params.projectNo || '';
  },

  /** ✅ 从缓存读项目名称 */
  projectNameFromCache() {
    if (!this.projectNo) return ''
    return sessionStorage.getItem(`project_name_${this.projectNo}`) || ''
  },

  /** ✅ 从缓存读合同名称 */
  contractNameFromCache() {
    const no = this.contractId;
    if (!no) return no;
    return sessionStorage.getItem(`contract_name_${no}`) || no;
  },

  /** ✅ 项目维度 */
  isFromProject() {
    return !!this.projectNo;   // ✅ 只认 projectNo
  },

  /** ✅ 面包屑数据 */
  breadcrumbList() {
    const list = [];

    // ✅ 首页
    list.push({
      label: this.isFromProject ? '项目主页' : '合同主页',
      to: this.isFromProject ? '/homepage/projects' : '/homepage/contracts'
    });

    if (this.isFromProject) {
      list.push({
        label: this.projectNameFromCache || this.projectNo,
        tooltip: this.projectNameFromCache || this.projectNo,
        to: `/homepage/project/${encodeURIComponent(this.projectNo)}`
      })
    }

    // ✅ 当前合同（不可点），显示缓存名称
    list.push({
      label: this.contractNameFromCache,
      tooltip: this.contractNameFromCache,
      disabled: true
    });

    return list;
  },


    // 合同信息项数组
    contractInfoItems() {
      return [
        { label: '合同编号', value: this.contractInfo.合同编号 },
        { label: '合同名称', value: this.contractInfo.合同名称 },
        { label: '客户', value: this.contractInfo.客户 },
        { label: '销售员', value: this.contractInfo.销售员 },
        { label: '创建时间', value: this.contractInfo.创建时间 },
        { label: '审核时间', value: this.contractInfo.审核时间 },
        { label: '合同总额', value: this.contractInfo.合同总额 },
        { label: '签订交货期', value: this.contractInfo.签订交货期 },
        { label: '回复交货期', value: this.contractInfo.回复交货期 },
        { label: '预计交付时间', value: this.contractInfo.计划完成时间 },
        { label: '交付进度', value: this.contractInfo.交付进度 },
        { label: '评审进度', value: this.contractInfo.评审进度, valueClass: this.reviewProgressClass },
        { label: '网点号', value: this.contractInfo.网点号 },
        { label: '总字号', value: this.contractInfo.总字号 },
        { label: '回款金额', value: this.contractInfo.回款总额 }
      ];
    },
  isMobile() {
    return window.innerWidth <= 768;
  },

  /** ✅ 评审进度的字体样式：已审核 → 加粗绿色；暂存 → 加粗蓝色；其它值不高亮 */
  reviewProgressClass() {
    const val = String(this.contractInfo.评审进度 || '').trim();
    if (val === '已审核') return 'review-approved';
    if (val === '暂存') return 'review-draft';
    return '';
  },

  contractTableColumns() {
    return this.isMobile ? 2 : 3;
  }
  },
  mounted() {
    this.initContractInfo();
    // this.getWorkOrderList();
  },
  methods: {
    /** 导出合同信息表格 */
    handleExportContractInfo() {
      if (this.$refs.contractInfoTable && this.$refs.contractInfoTable.handleExport) {
        this.$refs.contractInfoTable.handleExport()
      }
    },

    getCurrentUserCode() {
      const userCode = UserInfoUtils.getUserCode();
      if (!userCode) {
        this.$message.warning('未获取到用户信息，请重新登录');
        this.$router.push('/login');
        return null;
      }
      return userCode;
    },

    // // 初始化合同信息
    // initContractInfo() {
    //   // 优先从URL参数获取
    //   const contractInfoStr = this.$route.query.contractInfo;
    //   if (contractInfoStr) {
    //     try {
    //       this.contractInfo = JSON.parse(decodeURIComponent(contractInfoStr));
    //     } catch (error) {
    //       console.error('解析合同信息失败:', error);
    //       // 如果URL参数解析失败，尝试从路由参数获取合同编号
    //       this.getContractInfoFromApi();
    //     }
    //   } else {
    //     // 如果没有URL参数，从API获取
    //     this.getContractInfoFromApi();
    //   }
    // },

    initContractInfo() {
      this.getContractInfoFromApi();
    },
    
async getContractInfoFromApi() {
  const contractNo = this.contractId || this.$route.params.contractId;
  const userCode = this.getCurrentUserCode();
  if (!contractNo) {
    this.$message.warning('合同编号为空');
    return;
  }

  // ✅ 订单列表改由 orderProgress 组件自己拉数据（watch 合同号触发），这里不再统一置 loading

  // 构建新接口参数
  const params = {
    contractName: '',
    reviewProgress: '', // 评审进度，可根据需要扩展
    contractProgress: '', // 合同进度，可根据需要扩展
    startDate: '',
    endDate: '',
    sortField: "field0211", // 必填固定值
    customer: '', // 客户筛选，可根据需要扩展
    salesPerson: '', // 销售员筛选，可根据需要扩展
    updateStartDate: '', // 更新开始日期，可根据需要扩展
    updateEndDate: '', // 更新结束日期，可根据需要扩展
    reviewStartDate: '', // 审核开始日期，可根据需要扩展
    reviewEndDate: '', // 审核结束日期，可根据需要扩展
    signStartDate: '', // 签订开始日期，可根据需要扩展
    signEndDate: '', // 签订结束日期，可根据需要扩展
    replyStartDate: '', // 回复开始日期，可根据需要扩展
    replyEndDate: '', // 回复结束日期，可根据需要扩展
    userCode: userCode,
    department: '', // 部门筛选，可根据需要扩展
    projectNo: this.isFromProject ? this.projectNo : '',
    contractNo: contractNo || '',
    afterSalesNum: '',
    Paging_pageNumber: 1,
    Paging_pageSize: 1,
    estimatedAmount: '',
    contractNum: '',
    contractAmount: '',
    contractReviewNum: '',
    productType: '',
    biddingStartDate: '',
    biddingEndDate: '',
    "branchNumber":"",
    "deliveryProgress":"",
    "paymentRatio":"",
  };

  // ✅ 根据入口选择不同接口
  const apiMethod = this.isFromProject ? getContractListFromProject : getContractHomeList;

  try {
    const res = await apiMethod(params);

    if (res.data.code === 200) {
    const list = res.data.data.contractInfo || [];
    if (list.length === 0) {
      this.loading = false;
      this.$message.warning('未找到该合同信息');
      return;
    }

    const processed = this.processContractData(list);
    this.contractInfo = processed[0];

    // ✅ 合同信息回来后，orderProgress 通过 contractNo 变化自动去拉订单列表，这里不用再调用
  }else {
      this.loading = false;
      this.$message.error('获取合同信息失败');
    }
  } catch (error) {
    this.loading = false;
    this.$message.error('网络错误');
  }
},

  processContractData(data) {
    if (!data || !Array.isArray(data)) return [];

    return data.map(item => {
      let planDate = '';
      if (item.planFinishTime && typeof item.planFinishTime === 'object') {
        planDate = this.formatDate(item['planFinishTime'].plandate);
      }

      let 数据状态码 = '';
      if (item.billstatus_title === '已提交') 数据状态码 = 2;
      else if (item.billstatus_title === '已审核') 数据状态码 = 1;
      else if (item.billstatus_title === '暂存无用') 数据状态码 = 0;

      return {
        '创建时间': this.formatDate(item['创建时间'] || ''),
        '审核时间': this.formatDate(item['审核时间'] || ''),
        '合同编号': item['合同编号'] || '',
        '合同名称': item['合同名称'] || '',
        '评审进度': item['评审进度'] || '',
        '客户': item['客户'] || '',
        '销售员': item['销售员'] || '',
        '合同总额': item['合同总额'] || '',
        '签订交货期': this.formatDate(item['签订交货期'] || ''),
        '回复交货期': this.formatDate(item['回复交货期'] || ''),
        '计划完成时间': planDate,
        '交付进度': item['交付进度'] || '',
        '网点号': item['网点号'] || '',
        '总字号': item['总字号'] || '',
        '回款总额': item['回款总额'] || '',
        '回款比例': Number(
          item['paymentReceivedRate'] > 1 ? 1 : item['paymentReceivedRate']
        ),
        '数据状态码': 数据状态码,
        '状态详情': item['评审进度'] || '' // 悬浮提示显示关联的评审进度文字
      };
    });
  },

  formatDate(dateString) {
    if (!dateString) return '';
    return dateString.length > 10 ? dateString.substring(0, 10) : dateString;
  },

    // 获取任务单列表
    async getWorkOrderList(pageNo = this.currentPage, pageSize = this.pageSize) {
      // 订单列表加载态：请求发出前就置 true，表格显示加载条而不是「暂无信息」
      this.loading = true;
      // 调试用，使用传入的合同编号，如果没有则使用默认值
      const contractNo = this.contractInfo.合同编号;
      
      if (!contractNo) {
        this.loading = false;
        this.$message.warning('合同编号为空，无法获取任务单列表');
        return;
      }
      
      const params = {
        taskNo: this.taskNoSearchKeyword || "",
        contractNo: contractNo,
        model:this.productModelSearchKeyword || "",
        department: this.departmentSearchKeyword || "",
        productionProgress: this.productionProgressSearchKeyword || "",
        commitDate: this.commitDateSearchKeyword || "",
        planFinishDate: this.planFinishDateSearchKeyword || "",
        isIssue: this.isIssueSearchKeyword || "",
        pageNo: String(pageNo),
        pageSize: String(pageSize)
      };

      // 数量筛选：后端按 String 接收，直接传字符串（workOrderProgress 已保证是字符串）；未筛选时不传该字段
      if (this.qtySearchKeyword !== '' && this.qtySearchKeyword != null) {
        params.qty = String(this.qtySearchKeyword);
      }
      
      // ✅ 根据入口选择不同接口
      const apiMethod = this.isFromProject ? getOrdersListFromProject : getOrdersListFromContract;

      try {
        const res = await apiMethod(params);
        
        if (res.data.code == 200) {
          const info = res.data.data.information;
          this.workOrderData = this.processWorkOrderData(info.list || []);
          this.totalCounts = info.total;
        } else {
          this.$message.error(res.data.message || '获取数据失败');
        }
      } catch (error) {
        this.$message.error('网络错误，请检查连接');
      } finally {
        // 成功/失败都要结束加载，避免一直转圈
        this.loading = false;
      }
    },


    
    // 处理任务单数据
    processWorkOrderData(data) {
      if (!data || !Array.isArray(data)) return [];
      
      return data.map(item => {
        // 获取执行订单反馈的 context
        let feedbackContext = '';
        if (item['执行订单反馈'] && item['执行订单反馈'].context) {
          feedbackContext = item['执行订单反馈'].context;
        }
        
        // 获取派单时间的 dispatchDate
        let dispatchDate = '';
        if (item['派工日期'] && item['派工日期'].dispatchdate) {
          dispatchDate = this.formatDate(item['派工日期'].dispatchdate);
        }

        return {
          '任务号': item['任务号'] || '',
          '产品型号': item['FModel'] || '',
          '合同号': item['合同号'] || '',
          'BOM进度': item['BOM进度'] || '',
          // 数量：保留原始值，由 workOrderProgress 统一取整显示
          '数量': item['数量'] != null ? item['数量'] : '',
          // '设计人员': item['设计人员'] || '',
          // '加工图': item['加工图'] || '',
          // '小屋图纸': item['小屋图纸'] || '',
          // '装配图': item['装配图'] || '',
          // '防爆电器': item['防爆电器'] || '',
          // '机柜到货': item['机柜到货'] || '',
          '生产进度': item['生产进度'] || '',
          '生产车间': item['生产车间'] || '',
          '下达日期': this.formatDate(item['下达日期']) || '',
          '计划完工日期': this.formatDate(item['计划完工日期']) || '',
          '任务单执行反馈': feedbackContext,
          '派工日期': dispatchDate,
          '领料/投料': item['领料/投料'] || '0.0',
          '备注': item['备注'] || '',
          '物料属性': item['物料属性'] || '',
          '在途数': item['在途数'] != null ? item['在途数'] : '',
          '可用库存': item['可用库存'] != null ? item['可用库存'] : '',
          '是否有异常': item['是否有异常'] || '',
        };
      });
    },
    
    // // 获取当前用户工号
    // getCurrentUserCode() {
    //   const userCode = UserInfoUtils.getUserCode();
    //   if (!userCode) {
    //     this.$message.warning('未获取到用户信息，请重新登录');
    //     this.$router.push('/login');
    //     return null;
    //   }
    //   return userCode;
    // },
    
    // 处理获取数据事件（包含分页和筛选）
    handleGetData(filters) {
      this.currentPage = filters.currentPage || 1;
      this.pageSize = filters.pageSize || 10;
      this.taskNoSearchKeyword = filters.taskNo || '';
      this.productModelSearchKeyword = filters.model || '';
      this.contractNoSearchKeyword = filters.contractNo || '';
      this.departmentSearchKeyword = filters.department || '';
      this.productionProgressSearchKeyword = filters.productionProgress || '';
      this.commitDateSearchKeyword = filters.commitDate || '';
      this.planFinishDateSearchKeyword = filters.planFinishDate || '';
      this.isIssueSearchKeyword = filters.isIssue || '';
      this.qtySearchKeyword = filters.qty != null ? filters.qty : '';
      
      this.getWorkOrderList();
    },
    

    
    // 处理链接点击事件
    handleProductionClick(data) {
      this.goToProductProgressInfo(data);
    },
    
    // // 跳转到生产详情页
    // goToProductProgressInfo(data) {
    //   this.$router.push(`/homepage/contract?id=${data.任务号}`);
    //   this.$EventBus.$emit('currentPath', '/homepage/contract');
    //   this.$EventBus.$emit('noContract', true);
    // },
    // 处理设计按钮点击
handleDesignClick(data) {
  this.goToDesignProgressInfo(data);
},

/* ✅ 订单列表（orderProgress）里的按钮：最终都走上面这一套跳转逻辑，
   区别只是行数据的形状 —— 统一转成 { 任务号, 产品型号 } 再往下传 */

// 一级「订单」行的设计按钮：订单行没有任务号，沿用缓存里上一次的任务号
// （直接写空会污染设计页从 sessionStorage 取的值）
handleOrderDesignClick(row) {
  this.goToDesignProgressInfo({
    任务号: row['任务号'] || sessionStorage.getItem('design_current_workOrderId') || '',
    '产品型号': row['FModel'] || row['产品型号'] || ''
  });
},

// 二级「任务单」行的生产按钮：任务单行本身有任务号，直接用
handleOrderProductionClick(row) {
  this.goToProductProgressInfo({
    任务号: row['任务号'] || '',
    '产品型号': row['FModel'] || row['产品型号'] || ''
  });
},
    
// contractinfo.vue
goToProductProgressInfo(data) {
  const workOrderId = data.任务号;
  const contractId = this.contractId;
  const productModel = data['产品型号'] || '';

  // ✅ 产品型号按入口来源分别存入 sessionStorage
  const modelKey = this.isFromProject
    ? 'production_model_from_project'
    : 'production_model_from_contract';
  sessionStorage.setItem(modelKey, productModel);
  sessionStorage.setItem('production_current_contractNo', contractId);

  // ✅ 来自项目维度
  if (this.isFromProject) {

    this.$router.push({
      name: '任务生产信息2', // ✅ 项目维度
      params: {
        projectNo: this.projectNo,
        contractId,
        workOrderId
      }
    });

    this.$EventBus.$emit(
      'currentPath',
      `/homepage/project/${encodeURIComponent(this.projectNo)}/contract/${contractId}/production/${workOrderId}`
    );
  } else {
    // ✅ 来自合同维度
    this.$router.push({
      name: '任务生产信息1', // ✅ 合同维度
      params: {
        contractId,
        workOrderId
      }
    });

    this.$EventBus.$emit(
      'currentPath',
      `/homepage/contract/${contractId}/production/${workOrderId}`
    );
  }

  this.$EventBus.$emit('noworkOrder', true);
},

// 跳转到设计详情页
goToDesignProgressInfo(data) {
  const workOrderId = data.任务号;
  const contractId = this.contractId;
  const productModel = data['产品型号'] || '';

  // ✅ 任务单号和合同号存到 sessionStorage，设计页面从缓存取
  sessionStorage.setItem('design_current_workOrderId', workOrderId);
  sessionStorage.setItem('design_current_contractNo', contractId);
      sessionStorage.setItem('design_source', 'taskOrder');
  // ✅ 产品型号按入口来源分别存入 sessionStorage
  const modelKey = this.isFromProject
    ? 'production_model_from_project'
    : 'production_model_from_contract';
  sessionStorage.setItem(modelKey, productModel);


  // ✅ 来自项目维度：URL 只含 projectNo + parentModel
  if (this.isFromProject) {
    const projectName = this.projectName;
    sessionStorage.setItem('design_source', 'project');

    this.$router.push({
      name: '任务设计信息2',
      params: {
        projectNo: this.projectNo,
        parentModel: productModel || 'unknown'
      },
      // query: {
      //   projectName: projectName
      // }
    });

    this.$EventBus.$emit(
      'currentPath',
      `/homepage/project/${encodeURIComponent(this.projectNo)}/design/${encodeURIComponent(productModel || 'unknown')}`
    );
  } else {
    // ✅ 来自合同维度：URL 只含 parentModel
    sessionStorage.setItem('design_source', 'contract');

    this.$router.push({
      name: '任务设计信息1',
      params: {
        parentModel: productModel || 'unknown'
      }
    });

    this.$EventBus.$emit(
      'currentPath',
      `/homepage/contract/design/${encodeURIComponent(productModel || 'unknown')}`
    );
  }

  this.$EventBus.$emit('noworkOrder', true);
},
    
  // // ✅ 返回上级首页
  // goToHome() {
  //   if (this.isFromProject) {
  //     this.$router.push('/homepage/projects');
  //     this.$EventBus.$emit('currentPath', '/homepage/projects');
  //   } else {
  //     this.$router.push('/homepage/contracts');
  //     this.$EventBus.$emit('currentPath', '/homepage/contracts');
  //   }
  // },

  // // ✅ 项目维度：返回项目详情
  // goToProjectInfo() {
  //   this.$router.push({
  //     name: '项目信息',
  //     params: { projectName: this.projectName }
  //   });

  //   this.$EventBus.$emit(
  //     'currentPath',
  //     `/homepage/project/${encodeURIComponent(this.projectName)}`
  //   );
  // },

  // ✅ 新增：跳转到合同售后信息页面
  goToAftersaleInfo() {
  const contractId = this.contractInfo.合同编号;

  // ✅ 来自项目维度
  if (this.isFromProject) {
    const projectName = this.projectName;

    this.$router.push({
      name: '合同售后信息2', // ✅ 项目维度
      params: {
        projectName,
        contractId,
      }
    });

    this.$EventBus.$emit(
      'currentPath',
      `/homepage/project/${encodeURIComponent(projectName)}/contract/${contractId}/aftersale`
    );
  }else {
    this.$router.push({
      name: '合同售后信息1',
      params: {
        contractId
      }
    });
    
    this.$EventBus.$emit(
      'currentPath',
      `/homepage/contract/${contractId}/aftersale`
    );
  }
},    
    

  }
};
</script>

<style scoped lang="scss">

/* ① 卡片外侧留白：card-main 的圆角 / 阴影需要这段空间才不会被格子边缘吃掉
   ② 表格与卡片之间的固定边距 */
$card-gap: 0px;
$table-inset: 0px;

/* ✅ 宽度自适应 + 左右边距一致（对齐 projectinfo 的「合同信息」卡片）
   card-M 自身带 margin-right: 20px，而 cardWidth 是行内 style（原来写 99.9%），
   页面宽度一变就会出现「左边紧贴、右边留一条」的不对称。
   这里把本页所有卡片统一成：宽度撑满父容器、右边距清零、border-box。 */
::v-deep .card-main {
  width: 100% !important;
  min-width: 0 !important;
  margin-right: 0 !important;
  box-sizing: border-box !important;
}

// /* 最外层容器 */
// div {
// //   width: 100vw;
// //   height: 100vh;
// //   overflow: hidden;  
//   width: 100%;
//   height: 100%;
// //   overflow: hidden;
//   box-sizing: border-box;
// }

/* ============================================================
   布局（和 projectinfo.vue 同一套逻辑）
   ------------------------------------------------------------
   高度链：
     .main-view(homepage，height:100% + min-height:560px)
       → .contract-info-page(height:100%)
         → .card-main(外层 card-m，height:100%)
             ├─ .card-top  ← card-title（面包屑），自动高度
             └─ .card-box  ← ★ = card-main 高度 − card-title 高度
                  → .contract-dashboard
                      ├─ 上方：contract-info-section（固定高度 $info-h）
                      └─ 下方：task-section（吃掉剩余高度）
   ============================================================ */
$info-h: 220px;   /* 上方「合同信息」卡片的固定高度，想调只改这一个值 */

/* 页面根：撑满 .main-view */
.contract-info-page {
  height: 100%;
  box-sizing: border-box;
}

/* 外层 card-m：撑满页面 + 不要边框 / 阴影（电脑 & 手机都不要） */
.contract-info-card {
  height: 100% !important;
  width: 100% !important;
  border: none !important;
  box-shadow: none !important;
}

/* ⚠️★ 真正修掉「card-box 超出 main-view」的一步
   card-M 里 .card-box 写死的是 height:100%，跟上面的 .card-top(card-title) 一叠加就超出 card-main；
   更关键的是：.card-box 是 .card-main(flex 列) 的 flex 项，默认 min-height:auto
   （自动最小尺寸 = 内容的 min-content 高度），表格内容一高它就拒绝收缩，
   直接把 card-main / main-view 顶破 —— 这就是溢出的根因。
   三条一起改：
     flex:1 1 auto → 正好吃掉「card-main 减去 card-title」的剩余高度
     min-height:0  → 解除 flex 项「不能小于内容高度」的限制（★ 关键就是它）
     height:auto   → 别再按 100% 算，高度交给 flex 分配 */
.contract-info-card ::v-deep .card-box {
  flex: 1 1 auto !important;
  height: auto !important;
  min-height: 0 !important;
  box-sizing: border-box;
}

/* 主布局容器：吃掉 card-box 的全部高度，再切成「固定行 + 剩余行」 */
.contract-dashboard {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: $info-h 1fr;   /* ✅ 上方固定，下方吃剩余 */
  grid-template-areas: 
    "contract-info"
    "task";
  gap: 10px;
}

/* ============================================================
   上方：合同信息卡片 —— 固定高度（由 grid 第一行 $info-h 给定）
   ⚠️ min-height 别再写死 200px 一类的值：grid 行高已经定了，
      再叠加 min-height 只会让它在空间不够时拒绝收缩、顶破外层。
   ============================================================ */
.contract-info-section {
  grid-area: contract-info;
  min-height: 0;
  min-width: 0;   /* ⭐ grid / flex 项默认 min-width:auto，会把卡片顶宽、撑出容器 */
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: $card-gap;   /* 给 card-main 的影子留位置 */
  box-sizing: border-box;
}

/* ============================================================
   下方：订单列表卡片 —— 吃掉剩余高度
   ⚠️ 同样去掉写死的 min-height:350px，改成 0，让它可以自由收缩；
      里面的表格由 orderProgress / card-table 自己滚动，不会往外溢。
   ============================================================ */
.task-section {
  grid-area: task;
  min-height: 0;   /* ⭐★ 关键：允许收缩，表格才能在卡片内部滚，而不是把外层顶破 */
  min-width: 0;    /* ⭐ 同上；workOrder 自带 min-width: 350px 会破坏自适应 */
  width: 100%;
  height: 100%;    /* 撑满 1fr 那一行 */
  display: flex;
  flex-direction: column;
  padding: $card-gap;
  box-sizing: border-box;
}

/* ✅ 评审进度栏：已审核 → 加粗绿色；暂存 → 加粗蓝色
   （类名由 contractInfoItems 里的 valueClass 传进 CardInfoTable 的 .cell-text 上） */
.contract-info-section ::v-deep .review-approved {
  color: #67C23A !important;
  font-weight: 700 !important;
}
.contract-info-section ::v-deep .review-draft {
  color: #2564cf !important;
  font-weight: 700 !important;
}

/* ✅ 卡片本体：铺满各自格子，并把圆角 + 描边 + 阴影完整显示出来
   （card-M 自带 margin-right: 20px，会让卡片缩在里面且左右不对称，这里清掉） */
.contract-info-section ::v-deep .card-main,
.task-section ::v-deep .card-main {
  margin: 0;                                   /* card-M 自带 margin-right: 20px */
  border: 1px solid #e6ebf5;                   /* 卡片边框，看得见为止 */
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .12);  /* 略加深，配合浅灰底更明显 */
}

/* ✅ 订单列表（新的 orderProgress 组件）：跟 projectinfo 的「合同信息」卡片同一套逻辑
   组件根容器要「跟着所在行高走 + 表格在卡片内部滚动」，否则会超出这一行，
   卡片底部（边框 / 圆角）被裁掉。 */
.task-section ::v-deep .orderProgress {
  height: 100% !important;
  min-height: 0 !important;
  min-width: 0 !important;
  width: 100% !important;
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
}
.task-section ::v-deep .orderProgress .op-table-wrap { min-height: 0 !important; }

/* 旧组件 workOrderProgress 的规则先留着（其它页面还在用），本页已不再渲染 */
.task-section ::v-deep .workOrder {
  height: 100% !important;
  min-height: 0 !important;
  min-width: 0 !important;   /* ⭐ 组件里写死 min-width: 350px，窄屏会把卡片顶出容器 */
  width: 100% !important;
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
}

.task-section ::v-deep .card-m,
.task-section ::v-deep .card-box,
.task-section ::v-deep .card-table {
  flex: 1 !important;
  min-height: 0 !important;   /* ⭐ 允许收缩才会内部滚动，而不是撑破卡片 */
  display: flex !important;
  flex-direction: column !important;

}

/* card-box 再往里收一圈：表格不压到卡片边框上 */
.task-section ::v-deep .card-box {
  padding: $table-inset !important; /* card-M 自带 5px、手机端 2px!important */
}

.task-section ::v-deep .el-table {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}
.task-section ::v-deep .el-table__body-wrapper {
  flex: 1 !important;
  overflow-y: auto !important;
  min-height: 0 !important;
}

/* 进度条区域 */
.progress-section {
  margin-top: 20px;
  padding: 20px;
  background: rgba(37, 100, 207, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(37, 100, 207, 0.1);
  max-width: 100%;
  box-sizing: border-box;
}

.progress-item {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.progress-label {
  min-width: 100px;
  color: #808080;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}

.progress-bar {
  flex: 1;
  max-width: 400px;
  min-width: 200px;
}

.progress-value {
  min-width: 60px;
  color: #2564CF;
  font-size: 16px;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
}



/* ===========================
   手机端：上下两行（和桌面端同一套）
   =========================== */
$m-info-h: 270px;   /* 手机端「合同信息」卡片的固定高度 */

@media (max-width: 768px) {
  /* ✅ 上方合同信息固定高度，下方订单列表吃掉剩余
     ⚠️ 不再写死 calc(100vh - 110px)：高度改由外层 card-box 的 flex 分配决定，
        这样 card-box 才真正等于「main-view − card-title」 */
  .contract-dashboard {
    height: 100% !important;
    min-height: 0 !important;
    grid-template-rows: $m-info-h 1fr !important;
  }

  .contract-info-section {
    min-height: 0 !important;
    min-width: 0 !important;
  }

  /* 订单列表：吃掉剩余高度，表格在卡片内部滚动 */
  .task-section {
    min-height: 0 !important;   /* ⭐ 允许收缩 */
    min-width: 0 !important;
    height: 100% !important;
  }

  /* 窄屏下也保证卡片宽度 = 容器宽度，左右边距一致 */
  ::v-deep .card-main {
    width: 100% !important;
    min-width: 0 !important;
    margin-right: 0 !important;
  }

  /* 表格更紧凑 */
  .info-row {
    height: 26px !important;
  }

  .label-cell,
  .value-cell {
    font-size: 12px !important;
    padding: 0 0px !important;
  }
}
</style>


